/* eslint-disable consistent-return */
import { createSelector } from '@reduxjs/toolkit';
import { defaultUnitDefaultMock } from 'scenes/reportsList/mock/NewReportMocks';
import { ReportColumnItem } from 'shared/types';
import { RootState } from '..';

const metricsState = (state: RootState) => state.metricsState;

export const currentMetricSelector = createSelector([metricsState], (state) => {
  const currentMetric = state.metricsList.find(
    (metric) => metric.metricId === state.selectedMetricId
  );

  if (currentMetric) {
    return currentMetric;
  }
});

export const metricsForReportColumns = createSelector(
  [metricsState],
  (state) => {
    const unit = defaultUnitDefaultMock;

    const columnItems: ReportColumnItem[] = state.metricsList.map((m) => ({
      name: m.name,
      category: m.type,
      unit,
    }));

    return columnItems;
  }
);
